import React from 'react';

import { UserRoles } from 'common/constants';
import { HomePage } from 'pages';
import {
  CollectionpointsGridPage,
  CollectionpointsMapPage,
  CollectionpointsStatsPage,
  CollectionsGridPage,
  CollectorFormPage,
  CollectorsGridPage,
  ContainerOrdersGridPage,
  ContainersQrCodesGridPage,
  QrCodeFormPage,
  ContainertypesGridPage,
  CpGroupPage,
  CpGroupsPage,
  CpSubGroupPage,
  CpSubSubGroupPage,
  DriversGridPage,
  InternalTransactionsGridPage,
  MaterialsGridPage,
  RouteFormPage,
  RoutesGridPage,
  SeriesFormPage,
  SeriesGridPage,
  UserFormPage,
  UsersGridPage,
  VehiclesGridPage,
  WastereceptionpointsGridPage,
  WastereceptionpointTransactionsGridPage,
  EMailsRepoGridPage,
  ApplogFormPage,
  ApplogGridPage,
  AuditTrailFormPage,
  AuditTrailsPage,
  CollectionsRepDgrmPage,
  CollectionsSrvPivotPage,
  ContributorsGridPage,
  ContributionFormPage,
  ContributionsGridPage,
  ContributionsHistoryGridPage,
  ContributorFormPage,
  Idocs4FinaldestGridPage,
  Idocs4WasteReceptionGridPage,
  ParamsPage,
  CollectionordersStatusesPage,
  YearlyContributionsPage,
  UsersStatsPage,
} from 'shared-pages';
import { DriverFormPage } from 'shared-pages/pages/drivers/form/driver-form-page';
import { VehicleFormPage } from 'shared-pages/pages/vehicles/form/vehicle-form-page';
import { RegionsGridPage } from 'shared-pages/pages/regions';
import { SubregionsGridPage } from 'shared-pages/pages/subregions';
import { IdocFormPage, IdocsGridPage } from 'shared-pages/pages/idocs';
import { WRecPointFormPage } from 'shared-pages/pages/waste-reception-points/form/wrecpoint-form-page';
import { CollectionPointFormPage } from 'shared-pages/pages/collection-points/form/collectionpoint-form-page';
import { CollectionOrdersGridPage } from 'shared-pages/pages/collection-orders';
import OrderFormPage from 'shared-pages/pages/collection-orders/form/order-form-page';
import { CollectionFormPage } from 'shared-pages/pages/collections/form/collection-form-page';
import { InternalTransactionFormPage } from 'shared-pages/pages/internal-transactions-page/form/internal-transaction-form-page';
import { CollectionPointRequestFormPage } from 'shared-pages/pages/collection-point-requests/form/collectionpointRequest-form-page';
import { CollectionpointReqGridPage } from 'shared-pages/pages/collection-point-requests/grid/collectionpointreq-grid-page';
import ContainerOrderFormPage from 'shared-pages/pages/container-orders/form/containerOrder-form-page';
import { DriversAppEntriesGridPage } from 'shared-pages/pages/drivers-app-entries';
import { NomoiGridPage } from 'shared-pages/pages/nomoi/grid/nomoi-grid-page';
import { JobtypesFormPage } from 'shared-pages/pages/jobtypes/form/jobtypes-form-page';
import { JobtypesGridPage } from 'shared-pages/pages/jobtypes';

export class RouteType {
  name: string;
  path: string;
  component: React.ComponentType<any>;
  state?: object;
  userRoles?: UserRoles[] = [UserRoles.All];
}

export const commonRoutes: RouteType[] = [
  { name: 'Users', path: '/users', component: UsersGridPage },
  { name: 'User', path: '/user/:id', component: UserFormPage },

  { name: 'Materials', path: '/materials', component: MaterialsGridPage },
  { name: 'ContainerTypes', path: '/containers', component: ContainertypesGridPage },

  { name: 'CpGroups', path: '/cpgroups', component: CpGroupsPage },
  { name: 'CpGroup', path: '/cpgroup/:id', component: CpGroupPage },
  { name: 'CpSubGroup', path: '/cpsubgroup/:selected/:id', component: CpSubGroupPage },
  {
    name: 'CpSubSubGroup',
    path: '/cpsubsubgroup/:selected/:selectedSub/:id',
    component: CpSubSubGroupPage,
  },
  { name: 'Collectors', path: '/collectors', component: CollectorsGridPage },
  { name: 'Collector', path: '/collector/:id', component: CollectorFormPage },
  { name: 'Vehicles', path: '/vehicles', component: VehiclesGridPage },
  { name: 'Vehicle', path: '/vehicle/:id', component: VehicleFormPage },
  { name: 'Drivers', path: '/drivers', component: DriversGridPage },
  { name: 'Driver', path: '/driver/:id', component: DriverFormPage },
  { name: 'DriversAppEntries', path: '/drivers-app', component: DriversAppEntriesGridPage },
  { name: 'Series', path: '/series', component: SeriesGridPage },
  { name: 'SeriesForm', path: '/serie/:id', component: SeriesFormPage },
  { name: 'WasteReceptionPoints', path: '/wrecpoints', component: WastereceptionpointsGridPage },
  {
    name: 'WasteReceptionPointsDa',
    path: '/wrecpointsda',
    component: WastereceptionpointsGridPage,
  },
  { name: 'WasteReceptionPoint', path: '/wrecpoint/:id', component: WRecPointFormPage },
  { name: 'WasteReceptionPointDa', path: '/wrecpointda/:id', component: WRecPointFormPage },
  { name: 'Collectionpoints', path: '/collpoints', component: CollectionpointsGridPage },
  { name: 'Collectionpoint', path: '/collpoint/:id', component: CollectionPointFormPage },
  { name: 'CollectionpointContact', path: '/cp-contact/:id', component: HomePage },
  {
    name: 'ContainersQrCodes',
    path: '/containers-qrcodes',
    component: ContainersQrCodesGridPage,
  },
  { name: 'QrCode', path: '/QrCode/:id', component: QrCodeFormPage },
  {
    name: 'CollectionpointRequests',
    path: '/collectionpointrequests',
    component: CollectionpointReqGridPage,
  },
  {
    name: 'CollectionpointRequest',
    path: '/collectionpointrequest/:id',
    component: CollectionPointRequestFormPage,
  },
  { name: 'Jobtypes', path: '/jobtypes', component: JobtypesGridPage },
  { name: 'JobtypesForm', path: '/jobtype/:id', component: JobtypesFormPage },
  { name: 'Regions', path: '/regions', component: RegionsGridPage },
  { name: 'Subregions', path: '/subregions', component: SubregionsGridPage },
  { name: 'Nomoi', path: '/nomoi', component: NomoiGridPage },
  { name: 'Idocs', path: '/idocs', component: IdocsGridPage },
  { name: 'Idoc', path: '/idoc/:id', component: IdocFormPage },
  { name: 'Idocs4Finaldest', path: '/idocs4findest', component: Idocs4FinaldestGridPage },
  {
    name: 'Idocs4WasteReception',
    path: '/idocs4wastereception',
    component: Idocs4WasteReceptionGridPage,
  },
  { name: 'Orders', path: '/orders', component: CollectionOrdersGridPage },
  { name: 'Order', path: '/order/:id', component: OrderFormPage },
  { name: 'OrdersStatuses', path: '/orders-statuses', component: CollectionordersStatusesPage },
  { name: 'Routes', path: '/routes', component: RoutesGridPage },
  { name: 'Route', path: '/route/:id', component: RouteFormPage },
  { name: 'Collections', path: '/collections', component: CollectionsGridPage },
  { name: 'Collection', path: '/collection/:id', component: CollectionFormPage },
  { name: 'ITrans', path: '/itrans', component: InternalTransactionsGridPage },
  { name: 'ITran', path: '/itran/:id', component: InternalTransactionFormPage },
  { name: 'WrsTrans', path: '/wrstrans', component: WastereceptionpointTransactionsGridPage },
  { name: 'CPMap', path: '/cpmap', component: CollectionpointsMapPage },
  { name: 'CPStats', path: '/cpstats', component: CollectionpointsStatsPage },
  { name: 'ContainerOrders', path: '/containerorders', component: ContainerOrdersGridPage },
  { name: 'ContainerOrder', path: '/containerorder/:id', component: ContainerOrderFormPage },

  { name: 'AuditTrails', path: '/audit-trails', component: AuditTrailsPage },
  { name: 'AuditTrail', path: '/audit-trail/:id', component: AuditTrailFormPage },
  {
    name: 'Logs',
    path: '/applogs',
    component: ApplogGridPage,
    userRoles: [UserRoles.Admin],
  },
  {
    name: 'Log',
    path: '/applog/:id',
    component: ApplogFormPage,
    userRoles: [UserRoles.Admin],
  },
  { name: 'Mails', path: '/mails', component: EMailsRepoGridPage },
  {
    name: 'Params',
    path: '/params',
    component: ParamsPage,
    userRoles: [UserRoles.Admin],
  },
  {
    name: 'UsersStats',
    path: '/users-stats',
    component: UsersStatsPage,
    userRoles: [UserRoles.Admin],
  },
  { name: 'CollectionsRepDgrm', path: '/collections-rep-dgrm', component: CollectionsRepDgrmPage },
  { name: 'CollectionsPivot', path: '/collections-pivot', component: CollectionsSrvPivotPage },

  // Εισφορές
  { name: 'Contributors', path: '/contributors', component: ContributorsGridPage },
  { name: 'Contributor', path: '/contributor/:id', component: ContributorFormPage },
  { name: 'Contributions', path: '/contributions', component: ContributionsGridPage },
  { name: 'Contribution', path: '/contribution/:id', component: ContributionFormPage },
  {
    name: 'ContributionsHistory',
    path: '/contributionshistory',
    component: ContributionsHistoryGridPage,
  },
  { name: 'YearlyContributions', path: '/yearlycontributions', component: YearlyContributionsPage },
];
